var myServiceModule = angular.module("app.services", []);
myServiceModule.value("version", "1.0.0"); 
myServiceModule.service('selectionService', Patersons.SelectionService);
myServiceModule.service('tokenService', Patersons.TokenService);
myServiceModule.service('sessionService', Patersons.SessionService);
myServiceModule.service('bearerInjector', Patersons.BearerInjector);
myServiceModule.service('identityService', Patersons.IdentityService);
myServiceModule.service('analysisService', Patersons.AnalysisService);
myServiceModule.service('clientConfigService', Patersons.ClientConfigService);
myServiceModule.service('portfolioService', Patersons.PortfolioService);
myServiceModule.service('myDetailsService', Patersons.MyDetailsService);
myServiceModule.service('recaptchaVerifyService', Patersons.RecaptchaVerifyService);
myServiceModule.service('configurationService', Patersons.ConfigurationService);
myServiceModule.service('bannerService', Patersons.BannerService);
myServiceModule.service('reportService', Patersons.ReportService);
myServiceModule.service('reportDownloadService', Patersons.ReportDownloadService);
myServiceModule.service('navigationService', Patersons.NavigationService);
myServiceModule.service('bulkDownloadService', Patersons.BulkDownloadService);
myServiceModule.service('helpService', Patersons.HelpService);
myServiceModule.service('newsService', Patersons.NewsService);
myServiceModule.service('userCompanyService', Patersons.UserCompanyService);
myServiceModule.service('changeRequestService', Patersons.ChangeRequestService);
myServiceModule.service('morningStarService', Patersons.MorningStarService);
myServiceModule.service('researchFeedService', Patersons.ResearchFeedService);
myServiceModule.service('pdfBuilderService', Patersons.PDFBuilderService);
